module.exports = __webpack_public_path__ + "static/sirim-833e97d445606d8fbb157844d953d239.png";